import { render, staticRenderFns } from "./PopupReformationPlan.vue?vue&type=template&id=25e74868&scoped=true"
import script from "./PopupReformationPlan.vue?vue&type=script&lang=js"
export * from "./PopupReformationPlan.vue?vue&type=script&lang=js"
import style0 from "./PopupReformationPlan.vue?vue&type=style&index=0&id=25e74868&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e74868",
  null
  
)

export default component.exports